<template>
  <div class="page" :style="{ '--styleColor': bgcolor, 'backgroundImage': 'url('+bgimg+')','backgroundRepeat': 'no-repeat', 'backgroundSize':'100%','paddingTop':Mtop}">
    <TipsHbrb ref="child"></TipsHbrb>

    <div class="groupList">

      <div class="topTitle">
        <img src="@/assets/images/learn/wdjpk.png" alt="">
        <span>课程列表</span>
      </div>


      <div class="groupBox" v-for="(item,index) in list" :key="index">
        <div class="groupImg" @click="toList(item)">
          <img :src="item.gthumb" alt="">
        </div>
        <div class="groupInfo" @click="toList(item)">
          <span class="keshi">{{item.count}}节课</span>
          <span class="gtitle">{{item.gname}}</span>
        </div>
        <div class="viewInfo" @click="toList(item)">查看课程</div>   
        <div class="status ing">正在学</div>            
      </div>
      
 

      <!-- <div class="groupBox" v-for="(groupinfo, index) in groups" :key="index">
        <div class="groupImg" @click="toList(groupinfo)">
          <img :src="groupinfo.gthumb" alt="">
        </div>
        <div class="groupInfo" @click="toList(groupinfo)">
          <span class="keshi">{{groupinfo.count}}节课</span>
          <span class="gtitle">{{groupinfo.gname}}</span>
        </div>
        <div class="viewInfo" @click="toList(groupinfo)">查看课程</div>
      </div> -->

    </div>

  
    <div class="navBox">
      <div class="navTxt" @click="toIndex">
        <div class="icoBox"><img src="@/assets/images/learn/index_off.png" alt=""></div>
        <div class="icoTitle">首页</div>
      </div>
      <div class="navTxt" @click="toHome">
        <div class="icoBox"><img src="@/assets/images/learn/list_off.png" alt=""></div>
        <div class="icoTitle">课程列表</div>
      </div>
      <div class="navTxt" @click="toHistory">
        <div class="icoBox"><img src="@/assets/images/learn/history_on.png" alt=""></div>
        <div class="icoTitle">学习进度</div>
      </div>
    </div>
  </div>
</template>

<script>

//纵览顶部提示栏及唤起app
import TipsHbrb from '@/components/TipsHbrb.vue'
import zonglan from '@/utils/cp-zonglan.js'
import {reqLearnInfo, reqIsReg, reqGroups} from '@/api/learn.js'
import { isColorDark, checkClient } from "@/utils/tool";
import Cookies from 'js-cookie'
import jump2zonglan from '@/utils/jump2app-zonglan.js'

import bgimg from '@/assets/images/learn/pbg.jpg';

//分享
import { wxShare } from '@/utils/wxshare-wes2.com.js'
import { Dialog } from 'vant';

import Swiper from 'swiper';

export default {
  name: 'index',
  components: {
    TipsHbrb,
  },
  data () {
    return {
      bgimg:bgimg,
      bgcolor:'#e4f3fa',
      learnid:0,
      actInfo:"",
      token:"",
      accountId:'',
      uniqueId:'',
      userid:0,
      title:"",          
      showNotice:false,
      style:{},
      explain:"",
      groups:{},
      commends:{},
      keyword:'',
      banners: [], // 轮播图数据
      mySwiper: null, // 用于保存Swiper实例
      refreshing: false,
      loading: false,
      finished: false,
      list:[],
      currPage:1,
      Mtop:'6vw',
    }
  },  

  created (){
    this.getAppos();
    let learnid = this.$route.query.learnid;
    if(learnid) {
      this.learnid = learnid;
      this.actInit();  //加载活动信息
    }
  },
  mounted () { 
    if(this.learnid) {
      let accountId = this.$store.state.accountId;
      let uniqueId = this.$store.state.uniqueId;
      this.userid = this.$store.state.userid;         
      if(accountId && uniqueId){
        this.accountId = accountId;
        this.uniqueId = uniqueId;
      }else{
          if (process.env.NODE_ENV === 'development') {
              // 指定用户登录测试 begin
              // let accountId = '6358b3359f78a023d2b3ff8c';
              // let uniqueId = '672d5b4f05e822489b3ed594';
              // this.accountId = accountId;
              // this.uniqueId = uniqueId;
              // this.$store.commit("SET_ACCOUNTID",accountId);
              // this.$store.commit("SET_UNIQUEID",uniqueId);    
              // 指定用户登录测试 end
          } else if (process.env.NODE_ENV === 'production') {
              // 生产环境
              console.log('production');
          }
          this.cpLoad(true)  //日报客户端js-sdk加载并初始化
      }
    }else{
      this.$toast({
        icon: 'warning-o',
        message: '活动不存在！'
      });
    }
    this.getLocal();
  },  
  computed: {},
  watch: {
    commends() {
      // 监听banners数据变化
      // this.$nextTick(() => {
      //   this.initSwiper(); // 初始化Swiper
      // });
    },
  },
  methods: {
    getAppos(){
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        this.Mtop = '9vw';
      } else if (/(Android)/i.test(navigator.userAgent)) {
        this.Mtop = '6vw';
      } else {
        this.Mtop = '6vw';
      };
    },
    getLocal(){
      this.list = JSON.parse(localStorage.getItem('group_'+ this.learnid +'_'+this.userid));
    },
    onLoad() {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
          this.currPage = 1;
        }
        this.getList();        
        if (this.list.length >= 40) {
          this.finished = true;
        }
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    getList() {
      reqGroups({learnid:this.learnid, keyword:this.keyword, page:this.currPage, limit: 6}).then(res => {
        console.log('reqGroups',res);
        if(res.code==200) {
          this.list.push(...res.data.list);
          if(res.data.page==res.data.pages){
            this.finished = true; //全部数据加载完毕
          }else{
            this.currPage = this.currPage + 1;
          }
          this.loading = false; //当前下拉加载完毕

        } else {
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {
        console.log('err',err);
      }) 
    },
    toList(groupinfo){
      console.log('groupinfo',groupinfo);
      this.$router.push({ path: '/list',query:{...this.$route.query,learnid:groupinfo.learnid,gid:groupinfo.gid} })
    },
    initSwiper() {
      if (this.mySwiper) {
        this.mySwiper.destroy(); // 销毁旧的Swiper实例
      }
      this.mySwiper = new Swiper('#mySwiper', {
        loop: true, // 循环模式
        pagination: {
          el: '.swiper-pagination', // 分页器
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next', // 下一页按钮
          prevEl: '.swiper-button-prev', // 上一页按钮
        },
      });
    },
    onSearch(){
      console.log('search');
      this.list = [];
      this.refreshing = false;
      this.currPage = 1;
      this.onLoad();
    },
    login(){
      this.$refs.child.toLink()      
    },
    cpLoad(runAll) {
      let _this = this; 
      let cpMain = function() {        
          let is_login = false;
          CP.getDeviceInfo({
              completed: function(data){
                  CP.tools.writelog('get_device_info', data);                   
                  console.log('hbrb_version',data.version);
              },
              cpIncompatible: function () {
                  CP.tools.writelog('CP.getDeviceInfo', '此环境不支持此方法');
              }
          });
          //自身的业务代码，以下为调用样例
          CP.isLogin({  //判断是否登录的接口，
            completed: function(data){
            CP.tools.writelog('get_is_login', data);			
            if(data.is_login==1) {
              is_login=true;					
              //获取unique_id
              CP.getUniqueId({
                completed: function(data){
                  console.log('data.unique_id',data.unique_id);
                  _this.$store.commit("SET_UNIQUEID",data.unique_id);
                  _this.uniqueId = data.unique_id;
                  //获取account_id
                  CP.getAccountId({
                    completed: function(data){
                      console.log('data.account_id',data.account_id);
                      _this.$store.commit("SET_ACCOUNTID",data.account_id);
                      _this.accountId = data.account_id;
                      // _this.loginInit(data);
                    },
                    cpIncompatible: function () {
                      CP.tools.writelog('CP.getAccountId', '此环境不支持此方法');
                    }
                  });
                },
                cpIncompatible: function () {
                  CP.tools.writelog('CP.getUniqueId', '此环境不支持此方法');
                }
              });
            } else {
              //调用用户登录窗口
              CP.showLogin({
                completed: function(data){
                  if(data.is_login==1) {
                    console.log(data.account_id);
                    _this.$store.commit("SET_UNIQUEID",data.unique_id);
                    _this.$store.commit("SET_ACCOUNTID",data.account_id);
                    _this.uniqueId = data.unique_id;
                    _this.accountId = data.account_id;
                    _this.getLocal();
                  }
                  CP.tools.writelog('show_login', data);
                },
                cpIncompatible: function () {
                  CP.tools.writelog('CP.showLogin', '此环境不支持此方法');
                }
              });
            }   
          },
          cpIncompatible: function () {
            CP.tools.writelog('CP.isLogin', '此环境不支持此方法');
          }
          });
      }

      if(runAll) {
        let zjrbCp = document.createElement('script');
        zjrbCp.async = "async";
        zjrbCp.src = 'https://cdn-cp.tmuyun.com/jssdk/v1/zjrb-cp.v1.min.js';
        zjrbCp.charset = "UTF-8";
        document.body.appendChild(zjrbCp);     
        
        // localStorage.setItem('hbrb_account_id', '');
        // localStorage.setItem('hbrb_unique_id', '');

        zjrbCp.onload = function(){
          if(CP && typeof CP.ready === 'function'){
              console.log("CP准备就绪");
              CP.ready({
                debug:false,  //可选，是否是开启调试模式, 默认false
                es6Require: false, //可选，是否需要加载es6库，默认false
                ready:function(client_info){
                  //jssdk加载完成调用此方法
                  console.log('业务逻辑初始化开始');
                  cpMain();// 业务逻辑初始化的main函数
                },
                error: function (error) {
                  console.log('出现错误',error);
                }
              });
          }
        }
      } else {
        cpMain();// 业务逻辑初始化的main函数
      }       
    },
    actInit(){
      reqLearnInfo({learnid:this.learnid}).then(res => {
        console.log('res',res);
        if(res.code==200 || res.code==400) {
          if(res.code==400) {
            this.$toast({
                duration:0,
                icon: 'warning-o',
                message: res.msg
            });
          }
          this.actInfo = res.data.info; 
          this.commends = res.data.commends;   
   
          this.$store.commit("SET_ACTINFO",res.data.info); 
          this.$store.commit("SET_COMMENDS",res.data.commends);

          this.isBgDark = isColorDark(this.actInfo.bgcolor);

          //分享设置
          wxShare({
            title: this.actInfo.share_title,
            desc: this.actInfo.share_desc,
            img: this.actInfo.share_img
          })

        } else {
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {
        this.$toast({
              icon: 'warning-o',
              message: err
          });
      }) 

    },
    toStart(){
      if(this.actInfo.isreg==1) {
        this.toReg()
      } else {
        this.$router.push({ path: '/list', query:{...this.$route.query} })
        // this.$router.push({ path: '/list',query:this.$route.query })  //直接进入课程列表页
      }
    },
    toReg(){
      let _this = this; 
      if(this.accountId && this.uniqueId) {
        this.isReg()
      } else {
        Dialog.confirm({
          title: '消息提示',
          message: '请登录客户端后参与活动',
        })
          .then(() => {
            if (/(hbxw)/i.test(navigator.userAgent)) {
              _this.cpLoad(false);
            } else {
              _this.$refs.child.toLink();
            }
          })
          .catch(() => {
            // on cancel
          });
      }    
    },
    async noticeBox(){
      let result = await reqExplain({learnid:this.learnid});
      if(result.flag=='success') {
        this.explain = result.data.explain;   
      }
      this.showNotice = true;
    },
    async isReg(){

      reqIsReg({learnid:this.learnid,accountid:this.accountId,hbrb_unique_id:this.uniqueId}).then(res => {
        console.log('res',res);
        if(res.code==200) {
          // let markField = localStorage.getItem(this.learnid+'_markField');
          if(res.data){ //当前用户有登录记录
            localStorage.setItem(this.learnid+'_markField', this.accountId);
            localStorage.setItem(this.learnid+'_viewed', res.data.viewed);   
            this.$router.push({ path: '/list',query:this.$route.query })  //直接进入课程列表页
          } else {
            Cookies.set('ckplayer-player-cookie','') //当前用户没登录记录，则清空观看信息            
            localStorage.setItem(this.learnid+'_viewed', '');
            console.log('to reg');
            this.$router.push({ path: '/reg',query:this.$route.query })  //进入信息登记页
          }          
        } else {
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {
        this.$toast({
            icon: 'warning-o',
            message: err
        });
      }) 
    },    
    openApp(){
      jump2zonglan.toMLink()
    },    
    toIndex(){
      window.location.href="https://hbxw.hebnews.cn/qnyx/index.html#/?app_control=1101";
    },
    toHome(){
      this.$router.push({ path: '/index',query:this.$route.query })
    },
    toHistory(){
      this.$router.push({ path: '/history',query:this.$route.query })
    },    
    toMyCenter(){
      this.$router.push({ path: '/mycenter',query:this.$route.query })
    },
    toExam(){
      window.location.href="https://huodong.wes2.com/hudong/dati/155/app.html";
    }
  }
  
}
</script>
<style>
@media screen and (min-width: 1200px) {
  html,body { 
    display: flex; 
    justify-content: center; 
    font-size: 200px!important;
  }
}
</style>
<style lang="scss" scoped>
@import '@/assets/css/history.scss';
</style>